import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/search/tickets/hotelbeds',
    name: 'tickets-hotelbeds',
    component: () => import('../views/tickets/hotelbeds/agency/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/tickets/options/hotelbeds',
    name: 'tickets-options-hotelbeds',
    component: () => import('../views/tickets/hotelbeds/agency/options.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/tickets/reserve/hotelbeds',
    name: 'tickets-reserve-hotelbeds',
    component: () => import('../views/tickets/hotelbeds/agency/reserve.vue'),
    meta: { layout: appLayout }
  }
]
